import { getProxiedImageUrl } from './getProxiedImageUrl';

/** Served by the proxy when it can't fetch the original, so the raster never sees a failed image. */
export const RASTER_IMAGE_FALLBACK = 'https://placehold.co/1x1/ffffff/ffffff.png';

const PROXY_PREFIX = 'https://imageproxy.services.bkat.io/';

// innerHTML writes '&' in attributes as '&amp;'; the proxy needs the real URL.
const decodeAttr = (value: string) =>
	value
		.replace(/&quot;/g, '"')
		.replace(/&#39;|&apos;/g, "'")
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/&amp;/g, '&');

const escapeAttr = (value: string) => value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');

/**
 * Route a real signature's <img> sources through the image proxy for the raster copy
 * only (monday 13121390242): one unreachable signature image failed the raster's
 * setContent and 422'd the whole save. The preview and the send keep the originals.
 */
export function proxySignatureImagesForRaster(html: string): string {
	return html.replace(/<img\b[^>]*>/gi, tag => {
		const width = tag.match(/(?<![\w-])width\s*=\s*["']?(\d+)(?:px)?["']?(?=[\s/>])/i)?.[1];
		return tag
			.replace(/\s(?<![\w-])srcset\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
			.replace(/((?<![\w-])src\s*=\s*)("[^"]*"|'[^']*'|[^\s>]+)/i, (whole, attr: string, value: string) => {
				const src = decodeAttr(value.replace(/^["']|["']$/g, ''));
				if (!/^https?:\/\//i.test(src) || src.startsWith(PROXY_PREFIX)) return whole;
				// No pixel width → no resize, so a widthless spacer isn't blown up to 600px.
				const proxied = width
					? getProxiedImageUrl(src, width, 'auto', RASTER_IMAGE_FALLBACK, 'contain', true)
					: `${PROXY_PREFIX}?url=${encodeURIComponent(src)}&default=${encodeURIComponent(RASTER_IMAGE_FALLBACK)}`;
				return `${attr}"${escapeAttr(proxied)}"`;
			});
	});
}
